import { PageContainer } from "../../components/PageComponents";
import { Summary, UserActivity, TransactionsCount } from "./components";
import Leaderboard from "./Leaderboard";

const Dashboard = () => {
  return (
    <PageContainer title="Dashboard">
      <Summary />

      <div className="flex flex-col gap-6 w-full">
        <div className="flex flex-col gap-6 w-full lg:flex-row lg:items-start">
          <div className="w-full lg:w-2/3">
            <UserActivity />
          </div>
          <div className="w-full lg:w-1/3">
            <Leaderboard />
          </div>
        </div>

        <div className="w-full">
          <TransactionsCount />
        </div>
      </div>
    </PageContainer>
  );
};

export default Dashboard;
